'use client';

import Link from 'next/link';
import { cn } from '@/lib/utils';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';
import { useCart } from '@/components/ecommerce/cart-provider';

type MainNavProps = {
  transparent?: boolean;
};

export function MainNav({ transparent = false }: MainNavProps) {
  const { totalItems, openCart } = useCart();

  return (
    <>
      {/* Desktop navigation */}
      <div className="hidden lg:flex lg:gap-x-12">
        <Link
          href="/om-stiftelsen"
          className={cn(
            'text-sm font-semibold leading-6 transition hover:text-orange-600',
            transparent ? 'text-white' : 'text-neutral-700',
          )}
        >
          Om stiftelsen
        </Link>
        <Link
          href="/fond"
          className={cn(
            'text-sm font-semibold leading-6 transition hover:text-orange-600',
            transparent ? 'text-white' : 'text-neutral-700',
          )}
        >
          Fond
        </Link>
        <Link
          href="/forlag"
          className={cn(
            'text-sm font-semibold leading-6 transition hover:text-orange-600',
            transparent ? 'text-white' : 'text-neutral-700',
          )}
        >
          Förlag
        </Link>
        <Link
          href="/forandringsarbete"
          className={cn(
            'text-sm font-semibold leading-6 transition hover:text-orange-600',
            transparent ? 'text-white' : 'text-neutral-700',
          )}
        >
          Förändringsarbete
        </Link>
      </div>

      {/* Cart button */}
      <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end">
        <button
          type="button"
          onClick={openCart}
          className={cn(
            'relative inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold ring-1 ring-inset transition',
            transparent
              ? 'text-white ring-white/20 hover:bg-white/10'
              : 'text-neutral-700 ring-neutral-300 hover:bg-neutral-50',
          )}
          aria-label="Kundvagn"
        >
          <ShoppingBagIcon
            className={cn(
              'h-5 w-5',
              transparent ? 'text-white' : 'text-neutral-700',
            )}
          />
          {totalItems > 0 && (
            <span className="absolute -right-2 -top-2 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-orange-600 px-1 text-xs font-bold text-white">
              {totalItems}
            </span>
          )}
        </button>
      </div>
    </>
  );
}
